import { pxToDP, type StatsBarProps } from '@capsicum/common';
import styled, { useTheme } from 'styled-components';

import { Image } from '../../atoms/image/Image';
import { ProgressBar } from '../../atoms/progress-bar/ProgressBar';

export const StatsBar = ({
	imageSrc,
	leftAdditionalText,
	leftText,
	progressBar,
	rightAdditionalText,
	rightPercentage,
	testID,
	textColors
}: StatsBarProps) => {
	const { sizing } = useTheme();

	return (
		<S.Container data-testid={testID}>
			<S.TopSection>
				<S.TopLeftHalf>
					{imageSrc && (
						<S.StyledImage
							alt=""
							height={pxToDP(sizing.large)}
							src={imageSrc}
							width={pxToDP(sizing.large)}
						/>
					)}
					<S.AnnotationMarginRight $color={textColors?.leftText}>{leftText}</S.AnnotationMarginRight>
					{leftAdditionalText && (
						<S.Annotation $color={textColors?.leftAdditionalText}>{leftAdditionalText}</S.Annotation>
					)}
				</S.TopLeftHalf>

				<S.TopRightHalf>
					{rightAdditionalText && (
						<S.AnnotationMarginRight $color={textColors?.rightAdditionalText}>
							{rightAdditionalText}
						</S.AnnotationMarginRight>
					)}
					<S.Annotation $color={textColors?.rightPercentage}>{rightPercentage + '%'}</S.Annotation>
				</S.TopRightHalf>
			</S.TopSection>

			<ProgressBar {...progressBar} />
		</S.Container>
	);
};
namespace S {
	export const Container = styled.div`
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: ${({ theme }) => theme.spacings.large} 0;
	`;

	export const TopSection = styled.div`
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: ${({ theme }) => theme.spacings.xxxsmall};
	`;

	export const TopLeftHalf = styled.div`
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	`;

	export const TopRightHalf = styled.div`
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
	`;

	export const Annotation = styled.span<{ $color?: string }>`
		${({ theme }) => theme.fonts.text.caption1};
		color: ${({ $color, theme }) => $color || theme.colors.text.main.enabled};
	`;

	export const AnnotationMarginRight = styled(Annotation)`
		margin-right: ${({ theme }) => theme.spacings.xxxsmall};
	`;

	export const StyledImage = styled(Image)`
		margin-right: ${({ theme }) => theme.spacings.xxxsmall};
		padding: ${({ theme }) => theme.spacings.xxxxsmall};
		object-fit: cover;
	`;
}
